import type { ProductKind } from '@/types/monetization'

/** The kinds a person picks when creating a product (F-74). */
export const CREATABLE_KINDS: ProductKind[] = ['digital', 'physical']
/** Born with their event or course, 1:1, and never changed afterwards. */
export const LINKED_KINDS: ProductKind[] = ['event', 'course', 'show']
/** The six the picker draws, in this order; only digital and physical can be picked, the rest are born with their item. */
export const PICKER_KINDS: ProductKind[] = ['digital', 'physical', 'event', 'course', 'download', 'show']

/** Older responses carry no kind: they are digital. */
export const kindOf = (product: { kind?: ProductKind } | null | undefined): ProductKind => product?.kind ?? 'digital'

export const isLinkedKind = (kind: ProductKind | undefined): boolean => kind === 'event' || kind === 'course' || kind === 'show'

/** A price of zero is a free product (F-74); the API sends numbers or decimal strings. */
export const isFreePrice = (price: number | string | null | undefined): boolean => {
  if (price === null || price === undefined || price === '') return false
  return Number(price) === 0
}
